import {
  RmaLgmCommodityCode,
  RmaLgmCommodityCodes,
  RmaLgmCommodityNames,
} from './LgmCommodities';

export const StockguardLgmQuoteCategories = {
  PRODUCER_PREMIUM: 'Producer Premium',
  SUBSIDY: 'Subsidy',
  BASE_PREMIUM: 'Base Premium',
} as const;

export type StockguardLgmQuoteCategories =
  (typeof StockguardLgmQuoteCategories)[keyof typeof StockguardLgmQuoteCategories];

export const StockguardLgmPricesTitles = {
  LEAN_HOG: 'Lean Hog',
  SOYBEAN_MEAL: 'Soybean Meal',
  CORN: 'Corn',
  EXPECTED_GROSS_MARGIN: 'Expected Gross Margin',
} as const;

export type StockguardLgmPricesTitles =
  (typeof StockguardLgmPricesTitles)[keyof typeof StockguardLgmPricesTitles];
// Day of the month which determines if prices are published

export const LeanHogPricesCutoffDay = 20;

export const LgmDeductibles = {
  [RmaLgmCommodityNames.CATTLE]: [
    ...Array.from({ length: 16 }, (_, i) => 0 + i * 10),
  ],
  [RmaLgmCommodityNames.SWINE]: [
    ...Array.from({ length: 11 }, (_, i) => 0 + i * 2),
  ],
  [RmaLgmCommodityNames.DAIRY_CATTLE]: [
    ...Array.from({ length: 21 }, (_, i) => 0 + i * 0.1),
  ],
};

export function getLgmDeductiblesForCommodity(
  commodityCode: RmaLgmCommodityCode
) {
  switch (commodityCode) {
    case RmaLgmCommodityCodes.CATTLE:
      return LgmDeductibles[RmaLgmCommodityNames.CATTLE];
    case RmaLgmCommodityCodes.SWINE:
      return LgmDeductibles[RmaLgmCommodityNames.SWINE];
    case RmaLgmCommodityCodes.DAIRY_CATTLE:
      return LgmDeductibles[RmaLgmCommodityNames.DAIRY_CATTLE];
    default:
      return [];
  }
}

export const LgmTargetMarketingLength = {
  [RmaLgmCommodityNames.CATTLE]: 10,
  [RmaLgmCommodityNames.SWINE]: 5,
  [RmaLgmCommodityNames.DAIRY_CATTLE]: 10,
};
